import { type MultipleChoiceField } from '@/types/schema/fields';
import { type SearchViewInput } from '@/types/schema/views/SearchView';
import { MultiChoiceBaseInput } from './MultiChoiceBaseInput';

type MultipleChoiceInputProps = {
  field: MultipleChoiceField;
  intent: 'default' | 'destructive';
  formValueKey: string;
  searchViewFieldInput: SearchViewInput;
};

export function MultipleChoiceInput({
  field,
  intent,
  formValueKey,
  searchViewFieldInput
}: MultipleChoiceInputProps) {
  const blankOption = field.format?.blank; // This can be an empty string too
  const hasBlankOption = !!(field.format?.default === 'kn-blank' && blankOption);
  const inputOptions = field.format?.options || [];

  return (
    <MultiChoiceBaseInput
      blankOption={blankOption}
      hasBlankOption={hasBlankOption}
      options={inputOptions.map((option) => ({ label: option, value: option }))}
      formValueKey={formValueKey}
      multiType={searchViewFieldInput.multi_type}
      multiInput={searchViewFieldInput.multi_input}
      intent={intent}
    />
  );
}
